// extracted by mini-css-extract-plugin
export default {"alignBase":"ActionBar_alignBase__GId8p"};